import React from 'react';
import { Multiselect } from 'fw/forms';
 
class SponsorMultiselect extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            ...this.initialState(),
            loading: true,
        }
    }
 
    initialState = () => {
    }
 
    componentDidMount = () => {
        this.setState({
            loading: false,
            items: this.props.sponsors.map((item) => { return { label: item.name, value: item.id } })
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            items: nextProps.sponsors.map((item) => { return { label: item.name, value: item.id } })
        });
    }

    render() {
        if (this.state.loading)
            return null;

        return (
            <Multiselect
                {...this.props}
                items={this.state.items} />
        )
    }
}
 
export default SponsorMultiselect;
 
// Mark this as a form component
SponsorMultiselect.defaultProps = {
    formControl: true,
    managed: false
};


// WEBPACK FOOTER //
// ./src/areas/shared/controls/sponsorMultiselect/SponsorMultiselect.js